export const ENABLE_ITEM_INIT = 'ENABLE_ITEM_INIT';
export const ENABLE_ITEM_SUCCESS = 'ENABLE_ITEM_SUCCESS';
export const ENABLE_ITEM_FAILURE = 'ENABLE_ITEM_FAILURE';
export const DISABLE_ITEM_INIT = 'DISABLE_ITEM_INIT';
export const DISABLE_ITEM_SUCCESS = 'DISABLE_ITEM_SUCCESS';
export const DISABLE_ITEM_FAILURE = 'DISABLE_ITEM_FAILURE';
export const GET_PREFERENCES_SUCCESS = 'GET_PREFERENCES_SUCCESS';
export const SET_ACTION_IN_CONTEXT = 'SET_ACTION_IN_CONTEXT';
export const PUSH_ELEMENT_IN_HISTORY = 'PUSH_ELEMENT_IN_HISTORY';



// WEBPACK FOOTER //
// ./src/modules/serendipity/types.js